import { request } from "#/utils/request";
import { useQuery } from "@tanstack/react-query";

export const ENDPOINT_SEGURADORAS = "/seguradoras";

/**
 * @function getSeguradoras - busca lista de seguradoras
 */

async function getSeguradoras() {
  const { data } = await request.get<string[]>(ENDPOINT_SEGURADORAS);

  return data;
}

export function useSeguradoras() {
  return useQuery({
    queryKey: ["seguradoras"],
    queryFn: getSeguradoras,
  });
}

export default useSeguradoras;
